<template>
  <div>
    <div class="table-wrapper orders-history table-responsive">
      <table class="data table table-order-items history">
        <thead>
          <tr>
            <th class="text-center">Order #</th>
            <th class="text-center">Order Date</th>
            <th class="text-center">Order Qty</th>
            <th class="text-right">Order Total</th>
            <!-- <th scope="col" >Payment Status</th> -->
            <th class="text-center">Order Status</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(order, index) in orderInfo" :key="index">
            <td class="text-center">
           <router-link
                :to="{ name: 'OrderDetails', params: { id: order.id } }"
                class="action view"
              >
                {{ order.order_no }}
                  </router-link>
            </td>
            <td class="text-center">{{ order.order_date }}</td>
            <td class="text-center">
              {{ order.total_qty }}
            </td>
            <td class="text-right">
              <span class="price">৳{{ order.grand_total }}</span>
            </td>
            <td class="text-center">{{ order.status }}</td>
            <td data-th="Actions">
              <router-link
                :to="{ name: 'OrderDetails', params: { id: order.id } }"
                class="action view"
              >
                <span>View</span>
              </router-link>
            </td>
          </tr>
          <tr v-if="!loading">
            <td colspan="6" class="text-center">
              No order found
            </td>
          </tr>
        </tbody>
      </table>

      <nav class="d-flex justify-content-end my-5">
        <ul class="pagination">
          <li v-for="(item, k) in links" :key="k" :class="getPagingClass(item)">
            <a
              class="page-link"
              @click="getOrderInformation(item.url)"
              href="javascript:;"
              v-html="getPagingLabel(item)"
            ></a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      orderInfo: [],
      links: null
    };
  },
  methods: {
    getPagingLabel(item) {
      let string = item.label;
      string = string.replace("Next", "");
      string = string.replace("Previous", "");
      return string;
    },
    getPagingClass(item) {
      if (item.url && item.active === true) {
        return "page-item active";
      } else if (!item.url) {
        return "page-item disabled";
      } else {
        return "page-item";
      }
    },
    getOrderInformation(url) {
      this.$authHttp
        .get(url)
        .then(response => {
          this.orderInfo = response.data.orders.data;
          this.links = response.data.orders.links;
          //console.log(this.orderInfo);
          if (this.orderInfo.length < 1) this.loading = false;
        })
        .catch(e => {
          this.orderInfo = [];
          this.links = null;
          this.loading = false;
        });
    }
  },
  mounted() {
    this.getOrderInformation("getOrders");
  }
};
</script>
